import dayjs from "dayjs";

// L'option Madelin est disponible si :
// - L'activité est 'Travailleur Non Salarié'
// - La personne a entre 16 et 70 ans
// - Le type garantie est "Je recherche des garanties complètes"
const madelinAvailable = (activite, dateDeNaissance, typeGarantie) => {
    const date = dayjs(dateDeNaissance, 'DD/MM/YYYY', true)
    const age = dayjs().diff(date, 'year')

    console.debug("[madelinAvailable]", "age", age)

    const RG1 = activite === "Travailleur Non Salarié"
    const RG2 = typeGarantie !== '2'
    const RG3 = (age >= 16 && age < 70)

    return RG1 && RG2 && RG3 ? '1' : '0'
}

export {madelinAvailable}
